import styles from './Header.module.css'
import { useGetSelfQuery } from '../../../../../redux/services/TraderApi'
import React from 'react'
import formatNumber from '../../../../../utils/functions/formatNumber'
import { Loading } from '../../../../../components/Loading/Loading'

export const Rate = () => {
  const { data: trader, isLoading: TraderLoading } = useGetSelfQuery(undefined, {
    pollingInterval: 10000,
  })
  if (TraderLoading) {
    return <Loading />
  }

  return <></>
}
